// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container_1Vddq","image":"style_image_LppI7","text":"style_text_2vkC4","icon":"style_icon_2FqgC","textContainer":"style_textContainer_GQ9hB"};